<script setup lang="ts">
import type { PageDetailRow } from '@/db/content';
import DirectoryIndexPage from '@/components/DirectoryIndexPage.vue';

defineProps<{
  page: PageDetailRow;
}>();
</script>

<template>
  <DirectoryIndexPage list-kind="training-centres" :page="page" />
</template>
